import { Daycare, DaycareColors } from './Daycare'

export enum DaycareGroupType {
    agglomeration = 'agglomeration',
    association = 'association',
    community = 'community',
    private = 'private',
    county = 'county',
    city = 'city'
}

export interface DaycareGroup {
    id: number
    name: string
    location: string
    country: string
    type: DaycareGroupType
    active?: boolean
    created: Date
    trustees: Array<DaycareTrustee>
    daycares: Array<Daycare>
    colors?: DaycareColors
    downloadParams?: DaycareGroupDownloadParams
    logoBase64Data?: string
    daycarePSU: number
}

export interface DaycareTrustee {
    id: number
    userId: number
    firstname: string
    lastname: string
    email: string
    phone: string
    address: string
    zip: string
    city: string
    country: string
    main: boolean
    canWrite: boolean
}

export interface DaycareGroupsUrl {
    id: number
    text: string
    url: string
    icon: DaycareGroupUrlTypes
    daycareGroupId: number
    daycareIds?: number[]
}

export interface DaycareGroupDownloadParams {
    canDownloadImages: boolean
    canDownloadDocuments: boolean
}

export enum DaycareGroupUrlTypes {
    ExitToApp = 'ExitToApp',
    Euro = 'Euro',
    AttachMoney = 'AttachMoney',
    AccountBalance = 'AccountBalance',
    FolderOpen = 'FolderOpen',
    Construction = 'Construction',
    AlternateEmail = 'AlternateEmail',
    Call = 'Call',
    Apps = 'Apps',
    Home = 'Home',
    Security = 'Security',
    School = 'School',
    Newspaper = 'Newspaper',
    Balance = 'Balance',
    Dining = 'Dining',
    AirportShuttle = 'AirportShuttle',
    Celebration = 'Celebration',
    Attractions = 'Attractions',
    BeachAccess = 'BeachAccess',
    SportsSoccer = 'SportsSoccer'
}
